module.exports = "\r\n    <div class=\"box\">\r\n        <ul class=\"puzzle-wrap\">\r\n            <li \r\n                :class=\"{'puzzle': true, 'puzzle-empty': !puzzle}\" \r\n                v-for=\"puzzle in puzzles\" \r\n                v-text=\"puzzle\"\r\n                @click=\"moveFn($index)\"\r\n            ></li>\r\n        </ul>\r\n        <button class=\"btn btn-warning btn-block btn-reset\" @click=\"render\">重置游戏</button>\r\n    </div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 17
 ** module chunks = 0
 **/